import { useState, useCallback } from "react";

import { useDocumentProcessingWatcher } from "@/shared/hooks/useDocumentProcessingWatcher";

interface UseUploadProcessingOptions {
  onProcessed: () => void;
  onTimeout?: () => void;
  timeoutMs?: number;
}

export function useUploadProcessing({
  onProcessed,
  onTimeout,
  timeoutMs,
}: UseUploadProcessingOptions) {
  const [documentIds, setDocumentIds] = useState<number[]>([]);

  const handleProcessed = useCallback(() => {
    setDocumentIds([]);
    onProcessed();
  }, [onProcessed]);

  useDocumentProcessingWatcher({
    documentIds,
    onProcessed: handleProcessed,
    onTimeout,
    timeoutMs,
  });

  const startProcessing = useCallback((ids: number[]) => {
    setDocumentIds(ids);
  }, []);

  return {
    isProcessing: documentIds.length > 0,
    startProcessing,
  };
}
